import { useCallback } from 'react';
import { initLocationState, isLocationState } from 'src/modules/locationStateContext.ts';
import { SetURLSearchParams, useSearchParams } from 'react-router-dom';
import { LocationState } from 'src/modules/LocationState.ts';
import { updatedLocationState } from 'src/common/updatedLocationState.ts';
import { LOCATION_STORE_PARAM_NAME } from 'src/common/constants.ts';
import { readSearchParam } from 'src/common/readSearchParam.ts';

export const useLocationState = (): [
    LocationState,
    (state: LocationState) => URLSearchParams,
    URLSearchParams,
    SetURLSearchParams,
] => {
    const [searchParams, setSearchParams] = useSearchParams();
    const locationState = readSearchParam(
        searchParams,
        LOCATION_STORE_PARAM_NAME,
        { ...initLocationState },
        isLocationState,
    );
    const setState = useCallback((newState: LocationState): URLSearchParams => {
        updatedLocationState(searchParams, newState);
        setSearchParams(searchParams);
        return searchParams;
    }, [searchParams, setSearchParams]);
    return [locationState, setState, searchParams, setSearchParams];
};
